import { render, staticRenderFns } from "./PatientsMatrixTableBody.vue?vue&type=template&id=3b26063d"
import script from "./PatientsMatrixTableBody.vue?vue&type=script&lang=js"
export * from "./PatientsMatrixTableBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports